import { render, staticRenderFns } from "./assetmutation.vue?vue&type=template&id=851d0d7c"
import script from "./assetmutation.vue?vue&type=script&lang=js"
export * from "./assetmutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports